import React, { useEffect, useRef } from "react";

type ConfirmModalProps = {
  open: boolean;
  title: string;
  message: React.ReactNode;
  confirmLabel: string;
  // 削除など取り消せない操作なら true（実行ボタンを赤にする）
  danger?: boolean;
  // お知らせだけのとき true（「キャンセル」を出さない）
  hideCancel?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

// 確認のモーダル（window.confirm の代わり）。<dialog> を使うので Esc で閉じ、背面は操作できない
const ConfirmModal: React.FC<ConfirmModalProps> = ({ open, title, message, confirmLabel, danger = false, hideCancel = false, onConfirm, onCancel }) => {
  const dialogRef = useRef<HTMLDialogElement | null>(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    if (open && !dialog.open) {
      dialog.showModal();
      // showModal は最初のボタンにフォーカスを当て、黒い枠が出るので外す（Tab で移ればボタンに枠が出る）
      (document.activeElement as HTMLElement | null)?.blur();
    }
    if (!open && dialog.open) dialog.close();
  }, [open]);

  return (
    <dialog
      ref={dialogRef}
      className="c-modal"
      aria-labelledby="confirm-modal-title"
      onCancel={(e) => { e.preventDefault(); onCancel(); }}
      onClick={(e) => { if (e.target === dialogRef.current) onCancel(); }}
    >
      <div className="c-modal__inner">
        <h2 id="confirm-modal-title" className="c-modal__title">{title}</h2>
        <div className="c-modal__message">{message}</div>
        <div className="c-modal__actions">
          {!hideCancel && <button type="button" className="btn btn-secondary" onClick={onCancel}>キャンセル</button>}
          <button type="button" className={`btn ${danger ? "btn-danger" : "btn-primary"}`} onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </dialog>
  );
};

export default ConfirmModal;
